

























import {Component, Prop, Watch, Mixins} from "vue-property-decorator";
import {PROFILE_FIELDS_BASIC, UserProfile} from "../../../api/models/UserProfile";
import { PointRepository } from "../../../api/repositories/PointRepository";
import { ObjectRepository } from "../../../api/repositories/ObjectRepository";
import { RepositoryFabric } from "../../../api/repositories/RepositoryFabric";
import CloseBtn from "../../common/CloseBtn.vue";
import { Point } from "../../../api/models/Point";
import UserPointInfo from './UserPointInfo.vue';
import { groupFilter } from "../../../api/helpers/groupFilter";
import IsParticipantsLimited from "../../../mixins/isParticipantsLimited";
import { isBottom } from "../../../common/isBottom";
import {Debounce} from "vue-debounce-decorator";
import { EventBus } from "@common/EventBus";
import BounceSpinner from "../../../share/common/BounceSpinner.vue";


@Component({
    components: { CloseBtn, UserPointInfo, BounceSpinner }
})
export default class PointList extends Mixins(IsParticipantsLimited) {
    @Prop() isOpen: boolean;

    isShown = false;
    header: HTMLElement|null = null;
    profiles: Array<UserProfile> | null = null;
    pointsRepository: PointRepository = this.$repositories.get(RepositoryFabric.POINT);
    objectsRepository: ObjectRepository = this.$repositories.get(RepositoryFabric.OBJECT);
    isLoading = false;
    allProfilesCount = 0;
    page = 0;
    pageSize = 20;

    get myPoints(): Point {
        return this.$store.getters['points/points'] || {};
    }

    get myProfile() {
        return new UserProfile(this.$store.state.session?.profile);
    }

    get query() {
        return {
            where: {
                userId: {
                    $inQuery: {
                        schema: "EventMemberships",
                        where: {
                            eventSchemaId: process.env.VUE_APP_EVENTS_SCHEMA,
                            eventObjectId: this.$store.state.events.selected,
                            type: {
                                $in: ['speaker', 'participant']
                            },
                            status: {
                                $in: ['confirmed', 'mandatory']
                            },
                            isDeleted: false
                        },
                        "selectField": "userId"
                    }
                },
                ...groupFilter(this.participantsGroupIds())
            },
            include: PROFILE_FIELDS_BASIC,
            take: this.pageSize,
            skip: this.page * this.pageSize
        };
    }

    pointsFromProfile(profile: UserProfile) {
        return new Point({
            rank: profile.getField('rank'),
            points: profile.getField('points'),
            userId: profile.userId || 0,
            rankShift: profile.getField('rankShift')
        })

    }

    @Watch('isShown')
    async isOpenChanged(value: boolean) {
        if (value) {
            this.isShown = true;

            if (this.profiles === null) {
                this.isLoading = true;
                this.allProfilesCount = await this.objectsRepository.count(this.query);
                this.profiles = await this.fetchPage();

                this.isLoading = false;
                this.$refs['list'] && (this.$refs['list'] as HTMLElement).addEventListener('scroll', this.scrollHandler);
            }
        } else {
            this.$refs['list'] && (this.$refs['list'] as HTMLElement).removeEventListener('scroll', this.scrollHandler);
        }
    }

    async fetchPage() {
        return await this.pointsRepository.query(this.query, this.participantsGroupIds())
        .then((points) => {
            return points.map((point: Point) => {
                return new UserProfile(point);
            })
        });
    }

    close(e: MouseEvent) {
        e.preventDefault();
        this.isShown = false;
        setTimeout(() => {
            this.$emit('close')
        }, 500);
    }

    mounted() {
        this.isShown = true;
    }

    @Debounce(300)
    async scrollHandler() {
        const needToLoad = isBottom(this.$refs['list'] as HTMLElement)
            && this.profiles && this.profiles.length < this.allProfilesCount
            && !this.isLoading;

        if (needToLoad) {
            this.isLoading = true;
            this.page++;
            const profiles = await this.fetchPage();
            profiles.map(item => {
                this.profiles && this.profiles.push(item);
            })
            if (profiles.length == 0 && this.profiles) {
                this.allProfilesCount = this.profiles.length;
            }
            this.isLoading = false;
        }
    }

    showUserProfile(profile: UserProfile) {
        EventBus.$emit('showChatByUserId', profile.userId);
    }
}
